import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const initOrganizationAnimations = () => {
  const sections = document.querySelectorAll('[data-organization-section]');

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    if (section.dataset.organizationAnimated === 'true') {
      return;
    }

    const title = section.querySelector('[data-organization-title]');
    const image = section.querySelector('[data-organization-image]');
    const content = section.querySelector('[data-organization-content]');

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top 75%',
        once: true,
      },
      onComplete: () => {
        section.dataset.organizationAnimated = 'true';
      },
    });

    if (title) {
      timeline.from(title, {
        y: 32,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out',
      });
    }

    if (image) {
      timeline.from(
        image,
        {
          y: 40,
          opacity: 0,
          duration: 0.9,
          ease: 'power3.out',
        },
        '-=0.45'
      );
    }

    if (content) {
      timeline.from(
        content,
        {
          y: 32,
          opacity: 0,
          duration: 0.8,
          ease: 'power3.out',
        },
        '-=0.5'
      );
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOrganizationAnimations);
} else {
  initOrganizationAnimations();
}
